import { useCallback, useEffect, useState } from 'react'
import type { PortfolioLive } from '@shared/portfolio'
import { api } from '../lib/api'

/** The whole portfolio — every connected account and the recorded holdings — pushed live while mounted. */
export function usePortfolioLive(): { portfolio: PortfolioLive | null; streaming: boolean; refresh: () => void } {
  const [portfolio, setPortfolio] = useState<PortfolioLive | null>(null)
  const [streaming, setStreaming] = useState(false)
  useEffect(() => api.portfolioStream(setPortfolio, setStreaming), [])
  // After a change made here (a note, a recorded holding): don't wait for the next frame.
  const refresh = useCallback(() => {
    void api
      .portfolioLive()
      .then(setPortfolio)
      .catch(() => {})
  }, [])
  return { portfolio, streaming, refresh }
}
